(ns frontend.state.permissions
  (:require
   [frontend.state.current-session :as session]
   [common.permissions.account-permissions :as account-permissions]
   [common.permissions.entity-permissions :as entity-permissions]
   [common.schema.data-types :as data-types]
   [common.util :as cu]
   [common.schema.registry :as registry]
   [common.schema.field :as field]))

(defn- hide-external-id-for-non-configurable?
  [field-attribute entity-type]
  (let [field-schema (registry/get-field-schema @session/tenant-schema field-attribute)
        hidden-by-default? (= :not-in-use
                              (get-in field-schema [:field/default-visibility :field-visibility]))]
    (and (= field-attribute :common/external-id)
         hidden-by-default?
         (not (some #{entity-type} entity-permissions/CONFIGURABLE_ENTITIES)))))

;; FRONT END Permissions are resolved through this function
(defn access-to-field
  [{:keys [field-attribute entity-type optional-pipeline]}]
  (if (hide-external-id-for-non-configurable? field-attribute entity-type)
    nil
    (account-permissions/access-to-field @session/tenant
                                         @session/tenant-schema
                                         @session/account
                                         @session/role
                                         @session/current-permissions
                                         field-attribute
                                         entity-type
                                         optional-pipeline)))

(defn access-to-field-long
  [field-attribute entity-type optional-pipeline]
  (let [access (access-to-field {:field-attribute   field-attribute
                                 :entity-type       entity-type
                                 :optional-pipeline optional-pipeline})
        response (case access
                   :x :field.access/create
                   :w :field.access/write
                   :r :field.access/read
                   nil)]
    response))

(defn field-read-access?
  [field-attribute entity-type optional-pipeline]
  (let [res (case (access-to-field {:field-attribute   field-attribute
                                    :entity-type       entity-type
                                    :optional-pipeline optional-pipeline})
              :x true
              :w true
              :r true
              false)]
    res))

(defn field-path-read-access?
  [field-path entity-type optional-pipeline]
  (let [segments (cond
                   (vector? field-path) field-path
                   (keyword? field-path) [field-path]
                   (sequential? field-path) (vec field-path)
                   :else nil)]
    (when (seq segments)
      (loop [current-entity-type entity-type
             remaining segments]
        (let [attribute (first remaining)
              tail (next remaining)]
          (cond
            (or (nil? current-entity-type) (nil? attribute))
            false

            (not (field-read-access? attribute current-entity-type optional-pipeline))
            false

            (empty? tail)
            true

            :else
            (let [field-schema (registry/get-field-schema @session/tenant-schema attribute)
                  ref-data-type? (data-types/ref-type? (:field/data-type field-schema))
                  next-entity-type (first (:field/entity-types field-schema))]
              (if ref-data-type?
                (recur next-entity-type tail)
                false))))))))

(defn field-write-access?
  [field-attribute entity-type optional-pipeline]
  (let [res (case (access-to-field {:field-attribute   field-attribute
                                    :entity-type       entity-type
                                    :optional-pipeline optional-pipeline})
              :x true
              :w true
              false)]
    (if (session/is-read-only-user?)
      false
      res)))

(defn field-option-create-access?
  [field-attribute entity-type optional-pipeline]
  (let [res (case (access-to-field {:field-attribute   field-attribute
                                    :entity-type       entity-type
                                    :optional-pipeline optional-pipeline})
              :x true
              false)]
    res))

(defn available-tag-attribute-schemas
  [entity-type pipeline-id]
  (->> entity-type
       (registry/get-schema @session/tenant-schema)
       (filter (fn [[a {:keys [field/data-type named-value-attribute]}]]
                 (and named-value-attribute
                      (= data-type :data.type/ref-multi)
                      (field/tag-field? a)
                      (field-read-access? a entity-type pipeline-id))))))

;; for ref-attributes as well:
(defn get-access
  [{:keys [pipeline-id entity field]}]
  (cond
    (keyword? field)
    (field-read-access? field (:entity/type entity) pipeline-id)

    (and (vector? field)
         (cu/one-element? field))
    (field-read-access? (first field) (:entity/type entity) pipeline-id)

    (and (vector? field)
         (cu/multiple? field))
    (recur {:pipeline-id pipeline-id
            :entity      (-> (get entity (first field))
                             session/get-entity)
            :field       (subvec field 1)})

    :else nil))
